import Input from "../../../components/common/input";
import React, { useEffect, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../assets/icons/leftArrow.svg";
import { ReactComponent as RightArrow } from "../../../assets/icons/rightArrow.svg";
import { ReactComponent as CloseBlackIcon } from "../../../assets/icons/closeIcon.svg";
import Button from "../../../../common/components/button";
import TableName from "../../../components/common/tableName";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plusIcon.svg";
import { useSystemPopStore } from "../../../store/useSystemPopStore";
import { ReactComponent as CloseIcon } from "../../../assets/icons/closeWhiteIcon.svg";
import { ReactComponent as UploadImage } from "../../../assets/icons/uploadImage.svg";
import { ReactComponent as UploadOnImage } from "../../../assets/icons/uploadOnImage.svg";
import { useGetBranchProduct } from "../../../../common/hooks/console/transaction/useGetBranchProduct";
import { api_uri } from "../../../../common/hooks/utils/enum";
import { usePostBranchProduct } from "../../../../common/hooks/console/transaction/usePostBranchProduct";
import { usePutBranchProduct } from "../../../../common/hooks/console/transaction/usePutBranchProduct";
import { useDeleteBranchProduct } from "../../../../common/hooks/console/transaction/useDeleteBranchProduct";

const Product = ({ onClose, onSelect }: { onClose: () => void; onSelect: (image: { imageUrl: string; idx: number }) => void }) => {
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchTxt, setSearchTxt] = useState<string>("");
    const [inputValue, setInputValue] = useState<string>(currentPage?.toString() || "");
    const [registerPop, setRegisterPop] = useState(false);
    const [productImages, setProductImages] = useState<(File | string)[]>([]);
    const [productUploadPop, setProductUploadPop] = useState<boolean>(false);
    const [tempProductImages, setTempProductImages] = useState<(File | string)[]>([]);
    const [previewImage, setPreviewImage] = useState<string | null>(null);
    const [productName, setProductName] = useState<string>("");
    const [editPop, setEditPop] = useState(false);
    const [editProduct, setEditProduct] = useState<{
        idx: number;
        name: string;
        imageUrl: string;
    } | null>(null);

    const { data: productData } = useGetBranchProduct(currentPage, searchTxt);
    const { mutate: registerProduct } = usePostBranchProduct();
    const { mutate: modifyProduct } = usePutBranchProduct(editProduct?.idx || 0);
    const deleteMutation = useDeleteBranchProduct();

    const { showPop } = useSystemPopStore();

    const handleEditClick = (item: NonNullable<typeof productData>["data_list"][number]) => {
        setEditProduct({
            idx: item.branch_product_idx,
            name: item.branch_product_name,
            imageUrl: `${api_uri}/${item.file_name}`,
        });
        setProductName(item.branch_product_name);
        setProductImages([`${api_uri}/${item.file_name}`]);
        setEditPop(true);
    };

    const handleSaveProduct = () => {
        if (!productImages[0] || !productName) return;

        registerProduct(
            {
                branch_product_name: productName,
                branch_product_image: productImages[0] as File,
            },
            {
                onSuccess: () => {
                    setRegisterPop(false);
                    setProductName("");
                    setProductImages([]);
                    setTempProductImages([]);
                    setProductUploadPop(false);
                },
                onError: () => {},
            },
        );
    };

    const handleModifyProduct = () => {
        const image = productImages[0];

        modifyProduct(
            {
                branch_product_name: editProduct?.name ?? "",
                branch_product_image: typeof image === "string" ? null : image,
            },
            {
                onSuccess: () => {
                    setEditPop(false);
                    setProductName("");
                    setEditProduct(null);
                    setProductImages([]);
                    setTempProductImages([]);
                    setProductUploadPop(false);
                },
                onError: () => {},
            },
        );
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setInputValue(page.toString());
    };
    const handlePageInput = (value: string) => {
        if (value.trim() === "") {
            setInputValue("");
            return;
        }
        if (!/^\d*$/.test(value)) {
            return;
        }
        const pageNumber = Number(value.trim());
        if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > (productData?.last_page || 1)) {
            alert("페이지 범위를 벗어났습니다.");
            setInputValue(value.slice(0, -1));
            return;
        }

        setInputValue(value);
        handlePageChange(pageNumber);
    };

    const openImageUploadPop = (type: "ready" | "done" | "file" | "product") => {
        setProductUploadPop(true);
    };
    const handleImageDrop = (e: React.DragEvent<HTMLElement>, type: "ready" | "done" | "file" | "product") => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);

        const totalFiles = tempProductImages.length + files.length;

        if (totalFiles > 1) {
            showPop({
                title: "이미지는 최대 1장까지 <br /> 등록할 수 있습니다.",
                type: "negative",
                onRightClick: () => {},
            });
            return;
        }

        handleFiles(files, type);
    };

    const handleFiles = (files: File[], type: "ready" | "done" | "file" | "product") => {
        setTempProductImages(prev => [...prev, ...files].slice(0, 1));
    };
    const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>, type: "ready" | "done" | "file" | "product") => {
        if (e.target.files) {
            const files = Array.from(e.target.files);
            if (files.length + tempProductImages.length > 1) {
                showPop({
                    title: "이미지는 최대 1장까지 <br /> 등록할 수 있습니다.",
                    type: "negative",
                    onRightClick: () => {},
                });
                return;
            }

            setTempProductImages(prev => [...prev, ...files].slice(0, 1));
        }
    };

    const handleRemoveImage = (index: number, type: "ready" | "done" | "file" | "product", isPopup: boolean = false) => {
        if (isPopup) {
            setTempProductImages(prev => prev.filter((_, i) => i !== index));
        } else {
            setProductImages(prev => prev.filter((_, i) => i !== index));
            setTempProductImages(prev => prev.filter((_, i) => i !== index));
        }
    };
    const handleConfirmImages = (type: "ready" | "done" | "file" | "product") => {
        setProductImages(tempProductImages);
        setProductUploadPop(false);
    };

    const handlePreviewImage = (image: string | File) => {
        const imageUrl = typeof image === "string" ? image : URL.createObjectURL(image);
        setPreviewImage(imageUrl);
    };

    const handleCloseImageUploadPop = (type: "ready" | "done" | "file" | "product") => {
        setProductUploadPop(false);
    };

    const handleClickImage = (imageUrl: string, idx: number) => {
        onSelect({
            imageUrl: `${api_uri}/${imageUrl}`,
            idx,
        });
        onClose();
    };

    const handleDeleteProduct = (productIdx: number) => {
        showPop({
            title: "정말 삭제하시겠습니까?",
            type: "negative",
            rightButton: "확인",
            onRightClick: () => {
                deleteMutation.mutate(productIdx, {
                    onError: error => {
                        console.error("삭제 중 에러 발생:", error);
                    },
                });
            },
        });
    };

    useEffect(() => {
        const handlePaste = (e: ClipboardEvent) => {
            const items = e.clipboardData?.items;
            if (items) {
                const images: File[] = [];
                for (let i = 0; i < items.length; i++) {
                    if (items[i].kind === "file") {
                        const file = items[i].getAsFile();
                        if (file && file.type.startsWith("image/")) {
                            images.push(file);
                        }
                    }
                }
                if (images.length > 0) {
                    handleFiles(images, "product");
                }
            }
        };
        document.addEventListener("paste", handlePaste);
        return () => document.removeEventListener("paste", handlePaste);
    }, [productUploadPop]);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
            <div className="bg-white rounded-2xl shadow-custom min-w-[615px] h-[600px] py-5 relative">
                <div className="flex justify-between items-center px-9 py-3">
                    <div className="flex items-center gap-5">
                        <h2 className="text-2xl font-bold">상품사진 검색</h2>
                    </div>
                    <div className="flex items-center gap-5">
                        <div className="flex items-center gap-2">
                            <button onClick={() => currentPage && currentPage > 1 && handlePageChange(currentPage - 1)}>
                                <LeftArrow />
                            </button>
                            <Input
                                inputClassName="text-center"
                                className="w-20 text-center outline-0 text-sm flex"
                                value={inputValue ?? ""}
                                onChange={e => handlePageInput(e.target.value)}
                            />
                            <p className="text-gray3">/ {productData?.last_page}</p>
                            <button
                                onClick={() =>
                                    currentPage && currentPage < (productData?.last_page || 1) && handlePageChange(currentPage + 1)
                                }
                            >
                                <RightArrow />
                            </button>
                        </div>
                        <CloseBlackIcon className="cursor-pointer" onClick={onClose} />
                    </div>
                </div>
                <div className="px-9 py-2 flex justify-between items-center border-t border-gray4">
                    <div className="flex gap-2 items-center">
                        <p className="text-xs">총</p>
                        <p className="font-bold text-primary2 text-sm">{productData?.total_count}</p>
                    </div>
                    <Input
                        placeholder="검색"
                        status="none"
                        className="w-[240px]"
                        value={searchTxt ?? ""}
                        onChange={e => setSearchTxt(e.target.value)}
                    />
                </div>
                <div className="grid grid-cols-5 gap-x-4 gap-y-6 mt-5 px-6">
                    {productData?.data_list
                        .slice()
                        .reverse()
                        .map((item, index) => (
                            <div key={item.branch_product_idx} className="flex flex-col items-center text-sm gap-2">
                                <p className="w-24 truncate text-center">{item.branch_product_name}</p>
                                <img
                                    className="w-[100px] cursor-pointer object-contain h-[100px] rounded-[12px] border"
                                    src={`${api_uri}/${item.file_name}`}
                                    alt={item.original_name}
                                    onClick={() => handleClickImage(item.file_name, item.branch_product_idx)}
                                />
                                <div className="flex items-center gap-1">
                                    <Button size="S" className="w-12" onClick={() => handleEditClick(item)}>
                                        수정
                                    </Button>
                                    <Button size="S" className="w-12" onClick={() => handleDeleteProduct(item.branch_product_idx)}>
                                        삭제
                                    </Button>
                                </div>
                            </div>
                        ))}
                    {editPop && editProduct && (
                        <div className="absolute left-16 mt-2 w-[480px] border bg-white z-10 shadow-custom rounded-2xl">
                            <div className="flex items-center justify-between px-6 py-5">
                                <p className="text-[#1C1C1E] font-bold text-2xl">상품사진 수정</p>
                                <CloseBlackIcon
                                    className="cursor-pointer"
                                    onClick={() => {
                                        setEditPop(false);
                                        setEditProduct(null);
                                        setProductImages([]);
                                    }}
                                />
                            </div>
                            <div className="p-3 flex flex-col">
                                <div className="flex border-t-2 border-black">
                                    <TableName className="h-12" required>
                                        상품사진명
                                    </TableName>
                                    <Input
                                        className="w-full p-2"
                                        value={editProduct.name}
                                        onChange={e => setEditProduct(prev => prev && { ...prev, name: e.target.value })}
                                    />
                                </div>
                                <div className="flex border-y border-gray4">
                                    <TableName required>상품사진</TableName>
                                    <div className="flex items-center justify-between w-full">
                                        <div className="flex gap-2 flex-wrap p-2 w-full">
                                            {productImages.map((image, index) => (
                                                <div key={index} className="relative w-[60px] h-[60px] border rounded-xl overflow-hidden">
                                                    <img
                                                        alt="image"
                                                        src={typeof image === "string" ? image : URL.createObjectURL(image)}
                                                        className="w-full h-full object-contain cursor-pointer"
                                                        onClick={() => handlePreviewImage(image)}
                                                    />
                                                    <button
                                                        className="w-6 h-6 absolute top-0 right-0 bg-black bg-opacity-60 text-white"
                                                        onClick={() => handleRemoveImage(index, "product", false)}
                                                    >
                                                        <CloseIcon />
                                                    </button>
                                                </div>
                                            ))}

                                            {productImages.length < 1 && (
                                                <div
                                                    className={`
                  ${productUploadPop ? "border-primary2 text-primary2" : "border-gray5 border-dashed text-grayicon"} 
                  cursor-pointer w-full flex flex-col items-center border rounded-xl p-2
                `}
                                                    onClick={() => openImageUploadPop("product")}
                                                >
                                                    {productUploadPop ? <UploadOnImage /> : <UploadImage />}
                                                    <p className="text-sm">이미지 업로드</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* 이미지 업로드 팝업 */}
                                    {productUploadPop && (
                                        <div className="flex flex-col z-50 absolute w-[400px] bg-white rounded-2xl shadow-custom translate-x-[108px] translate-y-[73px]">
                                            <div className="flex w-full items-center px-5 justify-between py-5">
                                                <p className="text-primary1 text-2xl font-bold">이미지 업로드</p>
                                                <p className="text-sm">최대 1장까지 업로드 가능합니다.</p>
                                                <CloseBlackIcon
                                                    className="cursor-pointer"
                                                    onClick={() => handleCloseImageUploadPop("product")}
                                                />
                                            </div>
                                            <div className="px-6 pb-5 flex flex-col gap-2">
                                                <label
                                                    onDrop={e => handleImageDrop(e, "product")}
                                                    onDragOver={e => e.preventDefault()}
                                                    className="flex h-[160px] justify-center cursor-pointer flex-col items-center border border-gray5 border-dashed rounded-xl"
                                                >
                                                    <UploadImage className="w-[72px] h-[72px] mb-2" />
                                                    <p className="text-gray2 text-sm">이미지 업로드</p>
                                                    <p className="text-gray3 text-sm">(이미지를 드래그하거나 복사, 붙여넣기하여 등록)</p>
                                                    <input
                                                        type="file"
                                                        className="hidden"
                                                        multiple
                                                        accept="image/*"
                                                        onChange={event => handleImageUpload(event, "product")}
                                                    />
                                                </label>
                                                <div className="flex gap-1">
                                                    {tempProductImages.map((image, index) => (
                                                        <div
                                                            key={index}
                                                            className="relative w-[60px] h-[60px] border rounded-xl overflow-hidden"
                                                        >
                                                            <img
                                                                src={typeof image === "string" ? image : URL.createObjectURL(image)}
                                                                className="w-full h-full object-contain"
                                                                alt="image"
                                                            />
                                                            <button
                                                                className="w-6 h-6 absolute top-0 right-0 bg-black bg-opacity-60 text-white"
                                                                onClick={() => handleRemoveImage(index, "product", true)}
                                                            >
                                                                <CloseIcon />
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                                <Button
                                                    size="L"
                                                    status="regist"
                                                    className="w-full"
                                                    onClick={() => handleConfirmImages("product")}
                                                >
                                                    이미지 등록
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="flex w-full gap-2 py-2 px-3">
                                <Button className="w-full" size="L" onClick={() => setEditPop(false)}>
                                    취소
                                </Button>
                                <Button onClick={handleModifyProduct} status="regist" className="w-full" size="L">
                                    저장
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex gap-1 bottom-4 absolute w-full px-3">
                    <Button onClick={() => onClose()} className="w-full" size="L">
                        취소
                    </Button>
                    <Button
                        onClick={() => {
                            setRegisterPop(true);
                            setProductName("");
                            setProductImages([]);
                            setTempProductImages([]);
                            setProductUploadPop(false);
                        }}
                        status="regist"
                        className="w-full"
                        size="L"
                    >
                        등록하기
                    </Button>
                </div>
            </div>
            {registerPop && (
                <div className="absolute mt-2 w-[480px] border bg-white z-10 shadow-custom rounded-2xl">
                    <div className="flex items-center justify-between px-6 py-5">
                        <p className="text-[#1C1C1E] font-bold text-2xl">상품사진 등록</p>
                        <CloseBlackIcon
                            className="cursor-pointer"
                            onClick={() => {
                                setRegisterPop(false);
                            }}
                        />
                    </div>
                    <div className="p-3 flex flex-col">
                        <div className="flex border-t-2 border-black">
                            <TableName className="h-12" required>
                                상품사진명
                            </TableName>
                            <Input value={productName} className="w-full p-2" onChange={e => setProductName(e.target.value)} />
                        </div>
                        <div className="flex border-y border-gray4">
                            <TableName required>상품사진</TableName>
                            <div className="flex items-center justify-between w-full">
                                <div className="flex gap-2 flex-wrap p-2 w-full">
                                    {productImages.length >= 1 && (
                                        <div
                                            className={`${productUploadPop ? "border-primary2 text-primary2" : " border-gray5 border-dashed text-grayicon"} cursor-pointer w-[60px] flex flex-col items-center border rounded-xl p-2`}
                                            onClick={() => openImageUploadPop("product")}
                                        >
                                            <PlusIcon />
                                            <p className="text-sm">추가</p>
                                        </div>
                                    )}
                                    {productImages.map((image, index) => (
                                        <div key={index} className="relative w-[60px] h-[60px] border rounded-xl overflow-hidden">
                                            <img
                                                alt="image"
                                                src={typeof image === "string" ? image : URL.createObjectURL(image)}
                                                className="w-full h-full object-contain cursor-pointer"
                                                onClick={() => handlePreviewImage(image)}
                                            />
                                            <button
                                                className="w-6 h-6 absolute top-0 right-0 bg-black bg-opacity-60 text-white"
                                                onClick={() => handleRemoveImage(index, "product", false)}
                                            >
                                                <CloseIcon />
                                            </button>
                                        </div>
                                    ))}

                                    {productImages.length < 1 && (
                                        <div
                                            className={`
                                            ${productUploadPop ? "bg-primary4 border-primary2 text-primary2" : "border-gray5 border-dashed text-grayicon"} cursor-pointer w-full flex flex-col items-center border  rounded-xl p-2
                                        `}
                                            onClick={() => openImageUploadPop("product")}
                                        >
                                            {productUploadPop ? <UploadOnImage /> : <UploadImage />}
                                            <p className="text-sm ">이미지 업로드</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* 이미지 업로드 팝업 */}
                            {productUploadPop && (
                                <div className="flex flex-col z-50 absolute w-[400px] bg-white rounded-2xl shadow-custom translate-x-[108px] translate-y-[73px]">
                                    <div className="flex w-full  items-center px-5 justify-between py-5 ">
                                        <p className="text-primary1 text-2xl font-bold">이미지 업로드</p>
                                        <p className="text-sm">최대 1장까지 업로드 가능합니다.</p>
                                        <CloseBlackIcon className="cursor-pointer" onClick={() => handleCloseImageUploadPop("product")} />
                                    </div>
                                    <div className="px-6 pb-5 flex flex-col gap-2">
                                        <label
                                            onDrop={e => handleImageDrop(e, "product")}
                                            onDragOver={e => e.preventDefault()}
                                            className="flex h-[160px] justify-center cursor-pointer flex-col items-center border border-gray5 border-dashed rounded-xl"
                                        >
                                            <UploadImage className="w-[72px] h-[72px] mb-2" />
                                            <p className="text-gray2 text-sm">이미지 업로드</p>
                                            <p className="text-gray3 text-sm">(이미지를 드래그하거나 복사, 붙여넣기하여 등록)</p>
                                            <input
                                                type="file"
                                                className="hidden"
                                                multiple
                                                accept="image/*"
                                                onChange={event => handleImageUpload(event, "product")}
                                            />
                                        </label>
                                        <div className="flex gap-1">
                                            {tempProductImages.map((image, index) => (
                                                <div key={index} className="relative w-[60px] h-[60px] border rounded-xl overflow-hidden">
                                                    <img
                                                        src={typeof image === "string" ? image : URL.createObjectURL(image)}
                                                        className="w-full h-full object-contain"
                                                        alt="image"
                                                    />
                                                    <button
                                                        className="w-6 h-6 absolute top-0 right-0 bg-black bg-opacity-60 text-white"
                                                        onClick={() => handleRemoveImage(index, "product", true)}
                                                    >
                                                        <CloseIcon />
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                        <Button size="L" status="regist" className="w-full" onClick={() => handleConfirmImages("product")}>
                                            이미지 등록
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="flex w-full gap-2 py-2 px-3">
                        <Button className="w-full" size="L" onClick={() => setRegisterPop(false)}>
                            취소
                        </Button>
                        <Button onClick={handleSaveProduct} status="regist" className="w-full" size="L">
                            저장
                        </Button>
                    </div>
                </div>
            )}
            {previewImage && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
                    onClick={() => setPreviewImage(null)}
                >
                    <div className="w-[920px] bg-white rounded-2xl shadow-custom">
                        <div className="flex items-center justify-between px-6 py-5">
                            <p className="text-2xl font-bold">이미지 크게 보기</p>
                            <CloseBlackIcon className="cursor-pointer" onClick={() => setPreviewImage(null)} />
                        </div>
                        <div className="flex p-5  items-center justify-center ">
                            <img src={previewImage} alt="preview" className="object-contain max-h-[500px]" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Product;
